var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWinterSnowstar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 15H57V60H63V15Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6575 31.875L45.655 16.875L50.34 13.125L60 25.1975L69.655 13.125L74.34 16.875L62.3425 31.875H57.6575Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3016 26.0588L26.059 30.3014L57.8788 62.1212L62.1214 57.8786L30.3016 26.0588Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.455 41.7675L19.3625 39.65L20.0225 33.685L35.39 35.3925L33.6825 20.03L39.645 19.365L41.7675 38.455L38.455 41.7675Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60 57H15V63H60V57Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 74.345L13.125 69.66L25.1975 60L13.125 50.345L16.875 45.66L31.875 57.6575V62.3425L16.875 74.345Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8789 57.8789L26.0591 89.6987L30.3017 93.9414L62.1215 62.1216L57.8789 57.8789Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.65 100.637L33.6875 99.9775L35.3925 84.61L20.03 86.3175L19.365 80.355L38.455 78.2325L41.7675 81.545L39.65 100.637Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63 60H57V105H63V60Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.66 106.875L60 94.8025L50.345 106.875L45.66 103.125L57.6575 88.125H62.3425L74.345 103.125L69.66 106.875Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1214 57.8786L57.8788 62.1212L89.699 93.9412L93.9417 89.6986L62.1214 57.8786Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80.355 100.635L78.2325 81.545L81.545 78.2325L100.637 80.35L99.9775 86.315L84.61 84.6075L86.3175 99.97L80.355 100.635Z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M105 57H60V63H105V57Z",
    fill: "currentColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M103.125 74.34L88.125 62.3425V57.6575L103.125 45.655L106.875 50.34L94.8025 60L106.875 69.655L103.125 74.34Z",
    fill: "currentColor"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M89.699 26.0586L57.8789 57.8789L62.1215 62.1216L93.9416 30.3013L89.699 26.0586Z",
    fill: "currentColor"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.545 41.7675L78.2325 38.455L80.35 19.3625L86.3125 20.0225L84.6075 35.39L99.97 33.6825L100.635 39.645L81.545 41.7675Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinterSnowstar);
export default __webpack_public_path__ + "static/media/Winter_Snowstar.2938f2ee.svg";
export { ForwardRef as ReactComponent };